import { Divider } from "@mui/material";
import LocationsLayout from "../Locations/LocationsLayout/LocationsLayout.view";
import { useStyles } from "./DowntimeModuleHelp.styles";
import { useTranslation } from "react-i18next";
import helpLinksUS from "./helpLinksUS.json";
import helpLinkES from "./helpLinksES.json";
import helpLinkFR from "./helpLinksFR.json";
import { useMemo } from "react";

const DowntimeModuleHelp = () => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();

    const locale = useMemo(() => i18n.language.slice(0, 2).toLowerCase(), [i18n.language]);

    const videoList = locale === "es" ? helpLinkES : locale === "fr" ? helpLinkFR : helpLinksUS;
    return (
        <LocationsLayout headerTitle={t("locations.downtime_help.title")}>
            <div className={classes.mainWrapper}>
                <section className={classes.mainSection}>
                    <div className={classes.title}>{t("locations.downtime_help.description")}</div>
                    {videoList.map((section, index) => {
                        return (
                            <div key={section.id} className={classes.videoListSectionMainWrapper}>
                                <section className={classes.videoListSectionWrapper}>
                                    <div className={classes.videoListSectionTitle}>{section.sectionTitle}</div>
                                    <span className={classes.videoListSectionLength}>{`${section.videos.length} ${
                                        section.videos.length > 1
                                            ? t("locations.downtime_help.videos")
                                            : t("locations.downtime_help.video")
                                    }`}</span>
                                    <section className={classes.videoListWrapper}>
                                        {section.videos.map((video) => (
                                            <section key={video.id} className={classes.videoWrapper}>
                                                <div className={classes.videoIFrameWrapper}>
                                                    <iframe
                                                        className={classes.videoIFrame}
                                                        src={video.url}
                                                        title="YouTube video player"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                        allowFullScreen
                                                    />
                                                </div>
                                                <div className={classes.videoTitle}>{video.title}</div>
                                            </section>
                                        ))}
                                    </section>
                                </section>
                                {index !== videoList.length - 1 && (
                                    <Divider className={classes.videoListSectionDivider} />
                                )}
                            </div>
                        );
                    })}
                </section>
            </div>
        </LocationsLayout>
    );
};

export default DowntimeModuleHelp;
